import React, { useState } from "react";
import { Form, Input, Button, Typography, Alert } from "antd";
import { QrcodeOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import { updateCardQR } from "../../api/AdminRequest";

const { Title } = Typography;

function UpdateQR({ cardId }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const res = await updateCardQR(cardId, values.qrUrl);

      await toast.success("QR Code updated successfully", {
        position: "top-right",
        autoClose: 3000,
        theme: "dark",
      });
    } catch (error) {
      toast.error(error.message || "Failed to update QR code");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mt-6">
      <Title level={4}>Update QR Code</Title>

      <Alert
        message="Only use this if the QR code is broken or not redirecting correctly. This will only regenerate the stored QR image — it will NOT affect the physical printed card."
        type="warning"
        showIcon
        className="mb-4"
      />

      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="qrUrl"
          label={<span className="font-semibold">New QR Code URL</span>}
          rules={[
            { required: true, message: "Please enter the QR code URL" },
            { type: "url", message: "Please enter a valid URL" },
          ]}
        >
          <Input
            prefix={<QrcodeOutlined />}
            placeholder="https://zeeqr.info/profile-view/card-id"
            size="large"
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            loading={loading}
            className="bg-blue-600 hover:bg-blue-700"
          >
            Update QR Code
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
}

export default UpdateQR;
